import React, { useState, useEffect, useRef } from 'react'
import { Container, Row, Form, Button, Image } from "react-bootstrap";
import styled, { css } from 'styled-components';
import CKEditor from 'ckeditor4-react';
import { merge } from 'lodash';
import api from '../../../services/client';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, Redirect, useParams } from 'react-router-dom';
import routes from '../../routes';
import { useAuth } from '../../../auth/AuthContext';

//import './jobpost.css'

const CompContainer = styled(Container)`
@media screen and (max-width: 768px) {
    width: 90%;
}
    width: 45%;
    border-radius: 15px;
    border: 1px solid #f0f0f0;
    border-top: 4px solid #0A3BB4;
    margin-bottom: 5%;
`;

const CompForm = styled(Form)`
    margin: 0 8%;
    
    ${props =>
        props.index === '1' &&
        css`
            margin-top: 10%;
    `};

    & .form-label{
        font-size: 14px;
    }

    & input,select,textarea {
        background: #f9f9f9;
    }
`;

const FormTitle = styled(Form.Label)`
    font-weight: bold;
`;

const Title = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;
    margin: auto;
    padding-bottom: 20px;
    font-size: 40px;
    font-weight:500;
`;

const RemoveLogo = styled.div`
    color:red;
    font-size:15px; 
    font-weight:600; 
    margin-bottom:30px;
    cursor:pointer;

`;
function UpdateCompanyDetails(props) {
    const history = useHistory();
    const { currentUser } = useAuth();
    const { companyId } = useParams();
    const [ckEditorValue, setCkEditorValue] = useState([]);
    const [companyDetail, setCompanyDetail] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [companyLogo, setCompanyLogo] = useState();

    const imageBaseUrl='https://jobs.intellectualpoint.com/'

    useEffect(() => {
        api.getCompanyDetails(companyId).then(result => {
            setCompanyDetail(result.data);
            setShowForm(true);
        }).catch(error => {    });
    },[])

    const companyLogoRef = useRef('');

    const onEditorChange = e => {
        const value ={};
        value[e.editor.name] = e.editor.getData();
        setCkEditorValue(merge(ckEditorValue, value));
    }

    const onLogoChange = e => {
        if (e.target.files && e.target.files.length > 0) {
            setCompanyLogo(e.target.files[0]);
          }
    }

    const removeLogo = e => {
        debugger;
        companyLogoRef.current.value = '';
        setCompanyLogo();
    }

    const updateCompany = async company => {
        const data = await api.updateCompanyDetails(company, company.CompanyId).then((data) => {
            toast.success("Updated successfully",{
                onClose: () => history.push(routes.ADMINCOMPANIES)
            });
         })
        .catch(error => {
            toast.error(error.message);
            return error;
        });
    }

    const handleOnSubmit = async e => {
        e.preventDefault();        
        
        var formData = new FormData(e.target),
        formDataObj = Object.fromEntries(formData.entries());
        formDataObj.IsFeatured = 0;
        const companyDetails = merge(formDataObj, ckEditorValue);
        if(companyLogo) {
            var imagObject = new FormData();

            imagObject.append("FileName", formDataObj.CompanyName);
            imagObject.append("CompanyLogo", companyDetails.CompanyLogo);

            await api.uploadCompanyLogo(imagObject).then(
                async (logoPath) => {
                    companyDetails.CompanyLogo = logoPath.data;
                    await updateCompany(companyDetails);
                });
        } else {
            companyDetails.CompanyLogo = companyDetail.CompanyLogo;
            await updateCompany(companyDetails)
        }
    }

    return currentUser && currentUser.UserRole == "Admin" ? (showForm && (
        <>
        <Title> Update Company Details </Title>  
        <CompForm onSubmit={handleOnSubmit}>  
            <CompContainer>     
                <Form.Control type='hidden' name='CompanyId' value={companyDetail.CompanyId} />
                <Form.Control type='hidden' name='IsFeatured' value={companyDetail.IsFeatured} /> 
                <Form.Group className="mb-4" controlId="formName" style={{marginTop: '10%'}}>
                    <FormTitle>Company Name</FormTitle>
                    <Form.Control type="text" name="CompanyName" placeholder="Company Name" defaultValue={companyDetail.CompanyName} />
                </Form.Group>
                <Form.Group className="mb-4" controlId="formEmail" >
                    <FormTitle>Company Email</FormTitle>
                    <Form.Control type="email" name="Email" placeholder="Company Email" required defaultValue={companyDetail.Email}  />
                </Form.Group>
                <Form.Group className="mb-4" controlId="formTagline">
                    <FormTitle>Tagline</FormTitle> (optional)
                    <Form.Control type="text" name="Tagline" placeholder='Briefly describe your company' defaultValue={companyDetail.Tagline}/>
                </Form.Group>

                <Form.Group className="mb-4" controlId="formWebsite">
                    <FormTitle>Career Page Link</FormTitle>
                    <CKEditor onChange={onEditorChange} name='CareerLink' data={companyDetail.CareerLink ?? ''} required />
                    {/* <Form.Control type="text" name="CareerLink" placeholder=''  required  defaultValue={companyDetail.CareerLink} /> */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formDecription">
                    <FormTitle>Description</FormTitle>
                        <CKEditor onChange={onEditorChange} name='Description' data={companyDetail.Description ?? ''} />
                    {/* <Form.Control as="textarea" rows={3} name='Description'/> */}
                </Form.Group>

                <Form.Group className="mb-4" controlId="formVideo">
                    <FormTitle>Video</FormTitle> (optional)
                    <Form.Control type="text" name="VideoLink" placeholder='' defaultValue={companyDetail.VideoLink} />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formWebsite">
                    <FormTitle>Website</FormTitle> (optional)
                    <Form.Control type="text" name="Website" placeholder='' defaultValue={companyDetail.Website} />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formFacebook">
                    <FormTitle>Facebook</FormTitle> (optional)
                    <Form.Control type="text" name="Facebook" placeholder='' defaultValue={companyDetail.Facebook} />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formGPlus">
                    <FormTitle>Google+</FormTitle> (optional)
                    <Form.Control type="text" name="GPlus" placeholder='' defaultValue={companyDetail.GPlus} />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formLinkedIn">
                    <FormTitle>LinkedIn</FormTitle> (optional)
                    <Form.Control type="text" name="LinkedIn" placeholder='' defaultValue={companyDetail.LinkedIn} />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formTwitter">
                    <FormTitle>Twitter</FormTitle> (optional)
                    <Form.Control type="text" name="Twitter" placeholder='' defaultValue={companyDetail.Twitter} />
                </Form.Group>

                {/* <Row>
                    <Col>
                        <Form.Group className="mb-4" controlId="fromFeaturedJob">
                        <Form.Check
                            type="checkbox"
                            name="IsFeatured"
                            label={` Do you want this to be a Featured Company?`}
                            value={1}
                        />
                        </Form.Group>
                    </Col>
                </Row> */}

                <Form.Group controlId="formFile" className="mb-3">
                    <FormTitle>Company Logo</FormTitle><br />
                    <Form.Control type="file" name="CompanyLogo" onChange={onLogoChange} ref={companyLogoRef} /> 
                </Form.Group>
                <div style={{margin:'20px auto', position:'relative'}}>
                    
                    {companyLogo && (<>
                        <RemoveLogo onClick={removeLogo}> x Remove </RemoveLogo>
                         <Image src={URL.createObjectURL(companyLogo)} style ={{maxHeight: '140px'}} />
                         </>
                    )}    
                    {!companyLogo && companyDetail?.CompanyLogo && (<>
                         <Image src={companyDetail.CompanyLogo} style ={{maxHeight: '140px'}} />
                         </>
                    )}  
                </div>             
                <Row>
                    <Button type="submit" style={{height: '50px', backgroundColor:'#0A3BB4', borderRadius:'0px 0px 2px 2px'}}>
                        Submit {'>'}
                    </Button>
                </Row> 
            </CompContainer>
        </CompForm>
        <ToastContainer position="bottom-right" autoClose={2000} closeOnClick theme='colored'/>
        </> 
    ) ): (<Redirect to={routes.LOGIN_PAGE} />)
}

UpdateCompanyDetails.propTypes = {

}

export default UpdateCompanyDetails

